import React from "react";
import { StyleSheet, View } from "react-native";
import Svg, { Path } from "react-native-svg";

import CustomText from "../../../../../components/common/general/CustomText/CustomText";
import { colors } from "../../../../../styles/design-system";
import { clampPercentage } from "../../../../../utils/analyticsUtils";

interface ScoreGaugeProps {
  score: number;
  maxScore: number;
}

function ScoreGauge({ score, maxScore }: ScoreGaugeProps) {
  const percentage = clampPercentage(maxScore > 0 ? (score / maxScore) * 100 : 0);
  const radius = 44;
  const circumference = Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <View style={styles.gaugeWrap}>
      <Svg width={120} height={80} viewBox="0 0 120 80">
        <Path d="M 12 72 A 48 48 0 0 1 108 72" fill="none" stroke="#E5E7EB" strokeWidth={8} strokeLinecap="round" />
        <Path
          d="M 12 72 A 48 48 0 0 1 108 72"
          fill="none"
          stroke="#16A34A"
          strokeWidth={8}
          strokeLinecap="round"
          strokeDasharray={`${circumference}`}
          strokeDashoffset={strokeDashoffset}
        />
      </Svg>
      <View style={styles.gaugeLabel}>
        <CustomText
          text={`${score}`}
          useTranslationText={false}
          size="xxl"
          weight="ultraBold"
          style={styles.gaugeScore}
        />
        <CustomText
          text={`out of ${maxScore}`}
          useTranslationText={false}
          size="xs"
          weight="normal"
          style={styles.gaugeMax}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  gaugeWrap: {
    width: 120,
    height: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  gaugeLabel: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  gaugeScore: {
    color: colors.grey[900],
    lineHeight: 24,
  },
  gaugeMax: {
    color: colors.grey[500],
    fontSize: 11,
    lineHeight: 16,
  },
});

export default ScoreGauge;
